(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage-utils.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage-utils.js');

'use strict';

const {
  logger
} = svs.accountservices.iamPostMessage;

const noopLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {}
};
const safeLogger = logger || noopLogger;

const isOriginTrusted = event => {
  const origin = event.origin;
  const currentOrigin = window.location.origin;

  if (origin === currentOrigin) {
    return true;
  }
  try {
    const originUrl = new URL(origin);
    const currentUrl = new URL(currentOrigin);

    const getBaseDomain = hostname => hostname.replace(/^(www\.|local\.|app\.|login\.)+/, '').toLowerCase();
    const originBase = getBaseDomain(originUrl.hostname);
    const currentBase = getBaseDomain(currentUrl.hostname);

    return originBase === currentBase;
  } catch (error) {
    safeLogger.error('Error validating origin:', error);
    return false;
  }
};

const generateRequestId = () => "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));

Object.assign(svs.accountservices.iamPostMessage, {
  isOriginTrusted,
  generateRequestId
});

 })(window);